var map = {
	"./HPR.svg": "4cbf",
	"./Priscillak.svg": "ec85",
	"./XP.svg": "d015",
	"./accept-b&w.svg": "fcc1",
	"./cb-confirm.svg": "8e52",
	"./cb-details.svg": "f72b",
	"./cb-fullscreen-exit.svg": "1061",
	"./cb-fullscreen.svg": "1037",
	"./cb-grid.svg": "630e",
	"./cb-key.svg": "946d",
	"./cb-play.svg": "6c95",
	"./cb-refresh.svg": "7615",
	"./cb-reset.svg": "8eed",
	"./cb-settings.svg": "7128",
	"./cb-unlock.svg": "1f8f",
	"./cb-upload.svg": "364f",
	"./colorblind.svg": "ac51",
	"./confirm-b&w.svg": "309f",
	"./confirm.svg": "a98b",
	"./dark.svg": "d32b",
	"./delete-discussion.svg": "a475",
	"./details.svg": "acd1",
	"./discussion-b&w.svg": "1fbf",
	"./discussion-downvote.svg": "bf29",
	"./discussion-upvote.svg": "93c9",
	"./discussion.svg": "3b3a",
	"./download.svg": "24a4",
	"./edit-discussion.svg": "316d",
	"./edit_task.svg": "5432",
	"./emotion.svg": "d7e2",
	"./error-b&w.svg": "b6e1",
	"./error.svg": "2804",
	"./key.svg": "d769",
	"./last-activity.svg": "a064",
	"./light.svg": "f80a",
	"./next-b&w.svg": "0f40",
	"./next_task.svg": "63a7",
	"./no-profile-photo.svg": "e8dd",
	"./os-preference.svg": "a851",
	"./play.svg": "919e",
	"./profile-icon.svg": "f643",
	"./rating-b&w (1).svg": "05ec",
	"./rating-b&w.svg": "efae",
	"./rating.svg": "c0a3",
	"./refresh.svg": "2178",
	"./replay_task.svg": "80c6",
	"./reply-discussion.svg": "7268",
	"./resize-element.svg": "1a49",
	"./settings.svg": "cbdc",
	"./student.svg": "5967",
	"./unlock.svg": "7a47",
	"./upload.svg": "1ed6",
	"./w-edit_task.svg": "56cc",
	"./w-next_task.svg": "b72f",
	"./w-replay_task.svg": "d7f4",
	"./ziak.svg": "009f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";